function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-1-ps{fill:#1b1464}\r\n        "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "ps-Path_22212",
  d: "M56.88 148.686c-5.942-.034-10.858-12.164-10.858-18.342 0-10.091 7.57-12.3 10.487-12.3a12.067 12.067 0 0 1 3.957.973 8.845 8.845 0 0 0 2.259.648 7.032 7.032 0 0 0 1.621-.525 12.991 12.991 0 0 1 4.886-1.181h.011a10.014 10.014 0 0 1 8.38 4.232l.611.918-.88.664c-1.257.948-3.549 2.678-3.549 6.1a6.889 6.889 0 0 0 3.844 6.368c.551.331 1.121.673 1.121 1.42 0 .488-3.893 10.961-9.546 10.961a7.678 7.678 0 0 1-3.224-.779 6.536 6.536 0 0 0-2.869-.691 7.381 7.381 0 0 0-2.272.615 11.128 11.128 0 0 1-3.941.919z",
  className: "cls-1-ps",
  transform: "translate(-46.022 -108.76)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "ps-Path_22213",
  d: "M262.655 0c.147 5.309-3.649 8.991-7.441 8.76-.625-4.236 3.792-8.76 7.441-8.76z",
  className: "cls-1-ps",
  transform: "translate(-238.846)"
});

var SvgApplestore = function SvgApplestore(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ps-company",
    width: 32.749,
    height: 39.926,
    viewBox: "0 0 32.749 39.926",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgApplestore, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/applestore.7cab7870.svg";
export { ForwardRef as ReactComponent };